module.exports = __webpack_public_path__ + "static/media/cert_152.6fe4ca9f.jpg";